import { mainContainer } from '../../main.module';
import { SettingsInterface, SettingsService } from './settings.service';

export const Settings = mainContainer.get<SettingsInterface>(SettingsService);
